import { render } from "./BestSelling.vue?vue&type=template&id=6b14cc6f"
import script from "./BestSelling.vue?vue&type=script&lang=js"
export * from "./BestSelling.vue?vue&type=script&lang=js"

import "./BestSelling.vue?vue&type=style&index=0&id=6b14cc6f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__